import { Layout } from "antd";

import "./LandingPage.css";
import { HeroSection } from "./sections/HeroSection";
import { PlatformShowcaseSection } from "./sections/PlatformShowcaseSection";
import { ProblemSolutionSection } from "./sections/ProblemSolutionSection";
import { HowItWorksSection } from "./sections/HowItWorksSection";
import { FeaturesSection } from "./sections/FeaturesSection";
import { TestimonialsSection } from "./sections/TestimonialsSection";
import { PricingSection } from "./sections/PricingSection";
import { FinalCtaSection } from "./sections/FinalCtaSection";
import { LandingFooter } from "./sections/LandingFooter";

const { Content } = Layout;

export default function LandingPage() {
  return (
    <Layout className="landing-page">
      <Content>
        <HeroSection />
        <PlatformShowcaseSection />
        <ProblemSolutionSection />
        <HowItWorksSection />
        <FeaturesSection />
        <TestimonialsSection />
        <PricingSection />
        <FinalCtaSection />
      </Content>

      <LandingFooter />
    </Layout>
  );
}